import { PublicClientApplication } from "@azure/msal-browser";

const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_MICROSOFT_CLIENT_ID,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: `${window.location.origin}/microsoft`,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "sessionStorage",
    storeAuthStateInCookie: false,
  },
};

export const loginRequest = {
  scopes: ["User.Read"],
};

// Create and initialize MSAL instance once
export const msalInstance = new PublicClientApplication(msalConfig);

let msalInitializationPromise = null;

export const ensureMsalInitialized = () => {
  if (!msalInitializationPromise) {
    msalInitializationPromise = msalInstance
      .initialize()
      .catch((error) => {
        msalInitializationPromise = null;
        throw error;
      });
  }

  return msalInitializationPromise;
};
